import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `BackgroundActivity`
};

export function useBackgroundActivityStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          padding: `5px 0 5px 24px`,
          width: `35%`
        }
      ]
    }),
    []
  );
}
